<template>
  <div class="container u-pd-b-7">
    <div class="user-account _login">
      <div class="">
        <!-- ログイン -->
        <div class="login_controller_area u-mg-t-4">
          <sign-up-action-panel
          :regist-token="registToken"
          ></sign-up-action-panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import login from './login'
export default {
  name: 'identification-controllers',
  mixins: [login],
  props: {
    registToken: { type: String, default: ''},
  },
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/IdentificationControllers.vue